export default "__VITE_ASSET__CxAnoEMQ__"